module.exports = __webpack_public_path__ + "media/online-video-cutter.215b8dcc.mp4";